<template>
  <div class="report-container">
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Analysis Type</th>
          <td class="is-uppercase">{{ $route.query.analysis }}</td>
          <th>{{ analysisTypeLabel }}</th>
          <td>{{ $route.query.identifier }}</td>
        </tr>
        <tr>
          <th>Start</th>
          <td>{{ $route.query.from | date }}</td>
          <th>End</th>
          <td>{{ $route.query.to | date }}</td>
        </tr>
      </table>

      <div class="columns" v-if="services.length > 0">
        <div class="column">
          <table class="table is-fullwidth">
            <tr></tr>
            <tr></tr>
            <tr>
              <th>Total Service Requests</th>
              <td>{{ services.length }}</td>
            </tr>
            <tr>
              <th>Installation Requests</th>
              <td>{{ installationRequests.length }}</td>
            </tr>
            <tr>
              <th>Breakdown Requests</th>
              <td>{{ breakdownRequests.length }}</td>
            </tr>
            <tr>
              <th>Maintenance Requests</th>
              <td>{{ maintenanceRequests.length }}</td>
            </tr>
          </table>
        </div>
        <div class="column">
          <h1 class="is-size-4">Services Requests</h1>
          <chart-pie
            id="services-chart"
            :slices="[
              installationRequests.length,
              breakdownRequests.length,
              maintenanceRequests.length
            ]"
            :labels="['Installation', 'Breakdown', 'Maintenance']"
            colors="teal,coral,skyblue"
          ></chart-pie>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/http";
import ChartPie from "../../components/chart-pie";
export default {
  components: { ChartPie },
  data() {
    return {
      services: []
    };
  },
  computed: {
    installationRequests() {
      let component = this;
      let requests = [];
      component.services.forEach(service => {
        if (service.serviceType === "installation") {
          requests.push(service);
        }
      });
      return requests;
    },
    breakdownRequests() {
      let component = this;
      let requests = [];
      component.services.forEach(service => {
        if (service.serviceType === "breakdown") {
          requests.push(service);
        }
      });
      return requests;
    },
    maintenanceRequests() {
      let component = this;
      let requests = [];
      component.services.forEach(service => {
        if (service.serviceType === "maintenance") {
          requests.push(service);
        }
      });
      return requests;
    },
    analysisTypeLabel() {
      switch (this.analysis) {
        case "equipment":
          return "Model";
        case "customer":
          return "Customer";
        case "serial":
          return "Serial";
      }
    }
  },
  mounted() {
    let component = this;
    component.$store.commit("setNavVisible", false);
    http
      .post(`/report/service/${component.$route.query.analysis}`, {
        identifier: component.$route.query.identifier,
        form: component.$route.query.from,
        to: component.$route.query.to
      })
      .then(response => {
        component.services = response.data;
      });
  }
};
</script>
<style lang="scss" scoped>
@media print {
  .columns {
    display: flex !important;
  }
}
</style>
